import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20background%20with%20flowing%20warm%20golden%20and%20deep%20red%20gradients%20reminiscent%20of%20a%20movie%20theater%20curtain%2C%20soft%20dramatic%20lighting%2C%20elegant%20and%20artistic%20composition%2C%20dark%20atmosphere%20with%20warm%20highlights%2C%20no%20text%2C%20clean%20gradient%20background&width=1920&height=800&seq=hero-banner-movie&orientation=landscape"
        alt="八戒电影网 - 高清电影在线观看"
        title="八戒电影网"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight animate-fade-in-up">
              不缓冲<span className="text-primary-400">流畅播放</span>无广告
            </h1>
            <p className="text-white/80 text-sm md:text-lg max-w-xl mx-auto mb-8 leading-relaxed animate-fade-in-up animate-delay-100">
              八戒电影网采用高速服务器确保不缓冲流畅播放，高清影视资源无广告快速加载，告别卡顿等待享受极致观影体验
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up animate-delay-200">
              <Link
                to="/category/dongzuo"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </Link>
              <Link
                to="/category/kehuan"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-rocket-line text-lg"></i>
                热门推荐
              </Link>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
              {[
                { icon: 'ri-speed-line', label: '不缓冲', value: '极速加载' },
                { icon: 'ri-4k-line', label: '高清画质', value: '4K超清' },
                { icon: 'ri-advertisement-line', label: '无广告', value: '纯净观影' },
                { icon: 'ri-database-2-line', label: '海量资源', value: '10万+影片' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="w-10 h-10 mx-auto mb-1.5 flex items-center justify-center rounded-full bg-white/10 text-white/80">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <p className="text-white text-sm font-semibold whitespace-nowrap">{stat.label}</p>
                  <p className="text-white/50 text-xs whitespace-nowrap">{stat.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}